var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"clients",attrs:{"id":"clients"}},[_c('p',{staticClass:"clients__title"},[_vm._v("Nuestros clientes")]),_vm._v(" "),_c('section',{staticClass:"clients__images"},_vm._l((_vm.images),function(image,index){return _c('img',{attrs:{"src":image.img,"alt":""}})}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27afe308","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/Clients.vue
// module id = null
// module chunks = 